import { useMutation } from "@tanstack/react-query";
import pick from "lodash/pick";
import cloneDeep from "lodash/cloneDeep";
import omit from "lodash/omit";
import { EventsDefinitions } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
const extractSchedulerInfo = (eventDefinition) => {
  const clonedEventDefinition = cloneDeep(eventDefinition);
  const { _is_scheduled } = pick(clonedEventDefinition.config, ["_is_scheduled"]);
  clonedEventDefinition.config = omit(clonedEventDefinition.config, ["_is_scheduled"]);
  return { eventDefinition: clonedEventDefinition, isScheduled: _is_scheduled != null ? _is_scheduled : true };
};
const createEventDefinition = async (newEventDefinition) => {
  var _a;
  const { share_request, ...rest } = newEventDefinition;
  const { eventDefinition, isScheduled } = extractSchedulerInfo(rest);
  return EventsDefinitions.create(isScheduled, {
    entity: eventDefinition,
    share_request: {
      selected_collections: share_request == null ? void 0 : share_request.selected_collections,
      selected_grantee_capabilities: (_a = share_request == null ? void 0 : share_request.selected_grantee_capabilities) == null ? void 0 : _a.toJS()
    }
  });
};
const useEventDefinitionMutations = () => {
  const createMutation = useMutation({
    mutationFn: createEventDefinition,
    onError: (errorThrown) => {
      UserNotification.error(
        `Saving EventDefinition failed with status: ${errorThrown}`,
        "Could not save EventDefinition"
      );
    },
    onSuccess: (eventDefinition) => {
      UserNotification.success(
        "Event Definition created successfully",
        `Event Definition "${eventDefinition.title}" was created successfully.`
      );
    }
  });
  return { createEventDefinition: createMutation.mutateAsync };
};
export default useEventDefinitionMutations;
